'use client';

import AnimateLines from '@components/animate-lines/AnimateLines';
import Small from '@images/renders/infrastructure_images/Infra_Desktop_Webp/5.webp';
import Big from '@images/renders/infrastructure_images/Infra_Desktop_Webp/6.webp';
import { ScrollTrigger } from '@lib/tools/gsap-init';
import { useLayoutEffect, useRef, useState } from 'react';
import ParallaxMedia from '../../parallax-media/ParallaxMedia';
import style from './FourthScreenInfra.module.scss';

function FourthScreenInfra({ isMobile }) {
  const svgRef = useRef(null);

  const [toggle, setToggle] = useState(false);
  const [st18, setSt18] = useState(null);

  useLayoutEffect(() => {
    let timerId;

    if (!st18) {
      const element = svgRef.current;

      timerId = setTimeout(() => {
        setSt18(
          ScrollTrigger.create({
            trigger: element,
            id: 'fall',
            start: 'top center', // end: "bottom bottom",
            scroller: !isMobile ? '#smooth-wrapper' : 'body',
            scrub: true,
            pin: false,
            onToggle: () => {
              setTimeout(() => {
                setToggle(() => true);
              }, 500);
            },
          }),
        );
      }, 1000);
    }

    return () => {
      if (timerId) {
        clearTimeout(timerId);
      }
    };
  }, [svgRef, isMobile]);

  return (
    <div ref={svgRef} data-scroll className={style.fourthScreenContainer} id='four'>
      <div data-scroll data-scroll-speed='-0.5' data-scroll-target='#four' className={style.fourthScreenWrapper}>
        <div>
          <ParallaxMedia
            dataScroll={true}
            dataScrollSpeed='-2'
            dataScrollTarget='#four'
            src={Small}
            className={style.fourthScreenImgSmall}
            imagePlug={Small}
          />

          <ParallaxMedia
            dataScroll={true}
            dataScrollSpeed='0.5'
            dataScrollTarget='#four'
            src={Big}
            className={style.fourthScreenImgBig}
            imagePlug={Big}
          />
        </div>
        <div className={style.fourthScreenSvg_one}>
          <AnimateLines id='infrastructure-4' className={style.svgClass} toggle={toggle} />
        </div>
        <div className={style.fourthScreenTextBox}>
          <div className={style.fourthScreenTitle}>
            <p>Парк активностей </p>
            <p>и развлечений</p>
          </div>

          <div data-scroll data-scroll-speed='0.5' className={style.fourthScreenDescription}>
            <p>
              После школы тоже не&nbsp;придётся скучать. Линейный парк с&nbsp;вереницей спортивных и&nbsp;игровых
              площадок, полосой препятствий, скалодромом
              <br />
              направит энергию в&nbsp;активное и&nbsp;полезное русло.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FourthScreenInfra;
